import { Injectable, signal, WritableSignal } from '@angular/core';

// Tracks whether a booking step is currently persisting to the backend. It is the
// single source of truth for two pieces of UI that live in different components:
//   - the booking-footer loader-button (per step, via `[loading]`), and
//   - the page-level overlay in BookingPage that blocks the stepper + content so
//     nothing can be clicked (or "Terug"-ed) until the request settles.
// A step opts in by calling start()/stop() around its submit; BookingPage clears
// it on destroy as a safety net.
@Injectable({ providedIn: 'root' })
export class BookingSubmitService {
  public readonly submitting: WritableSignal<boolean> = signal<boolean>(false);

  // Ná een geslaagde confirm-POST: de wizard is terminaal geworden. bookingSubmittedGuard
  // bounct elke wizard-stap naar het autooverzicht; StartPage reset de vlag.
  public readonly submitted: WritableSignal<boolean> = signal<boolean>(false);

  public start(): void {
    this.submitting.set(true);
  }

  public stop(): void {
    this.submitting.set(false);
  }
}
